// Import F7 Styles
import 'normalize.css';

// Import Icons and App Custom Styles
import '../css/app.less';
